import type { SeoAlternateLink } from "@amtana/browser";

import { WARIKE_WORDS } from "./warike-words.ts";

// What warike.tech's head names on a page beside the page itself: the feed on every page, and the
// page's own Markdown twin where it has one (WK-TASK-011).

const FEED: SeoAlternateLink = {
  type: "application/rss+xml",
  title: WARIKE_WORDS.feedTitle,
  href: "/blog/rss.xml",
};

export const machineLinks = (path?: string): readonly SeoAlternateLink[] =>
  path ? [{ type: "text/markdown", title: WARIKE_WORDS.twinTitle, href: `${path}.md` }, FEED] : [FEED];
